import React from "react";
import HomeSvg from "../svg/HomeSvg";
import TrendingSvg from "../svg/TrendingSvg";
import LayerSvg from "../svg/LayerSvg";
import "./nav.scss";
const Nav = () => {
  return (
    <div className="nav_wrap">
      <ul className="nav_list">
        <li>
          <a href="/" className="nav_item active">
            <HomeSvg />
            Home
          </a>
        </li>
        <li>
          <a href="/" className="nav_item">
            <TrendingSvg />
            Trending
          </a>
        </li>
        <li>
          <a href="/" className="nav_item">
            <LayerSvg />
            Subcriptions
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Nav;
